// JobDetailsSkeleton.jsx
import { Box, Skeleton, Stack } from "@mui/material";

export default function JobDetailsSkeleton() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={1.5}>
        <Skeleton variant="text" width="50%" height={36} />
        <Stack direction="row" spacing={1}>
          <Skeleton variant="text" width={140} />
          <Skeleton variant="text" width={90} />
          <Skeleton variant="text" width={110} />
        </Stack>
        <Skeleton variant="text" width="30%" />
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="rectangular" height={260} />
      </Stack>
    </Box>
  );
}
